const features = (state = {}, action) => {
  switch (action.type) {
    case 'GET_FEATURES':
      return {
        ...state,
        ...action.data,
      };
    case 'GET_FEATURES_ERROR':
      return state;
    default:
      return state;
  }
};

export default features;
